import React from 'react';
import { useTranslation } from 'react-i18next';
import { PipeSeparator } from '../utils';

import 'bootstrap/dist/css/bootstrap.css';
import './Header.css'

const LangSwitch: React.FC<{ lang: string }> = props => {
    const { i18n } = useTranslation();
    const { lang } = props

    const switchLanguage = () => {
        i18n.changeLanguage(lang)
        document.cookie = `lang=${lang};expires=Thu, 18 Dec 2099 12:00:00 UTC; path=/`
    }

    return (
        <span
            className="text-dark lang-button"
            onClick={switchLanguage}
            data-cy={`lang-button-${lang}`}
            >
            {lang}
        </span>
    )
}

const Header: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div>
            <div className="text-center mt-2">
                <img alt="logo" src="http://pokrok.fsi.ujep.cz/sites/default/files/logo_pokrok_4.png" />
            </div>
            <div className="container mt-3">
                <p className="text-right">
                    <LangSwitch lang="cz" />
                    <PipeSeparator />
                    <LangSwitch lang="en" />
                    <PipeSeparator />
                    <LangSwitch lang="de" />
                </p>
            </div>
            <div className="container text-center ">
                <h1>{t("Technical terminology glossary")}</h1>
            </div>
        </div>
    );
}

export default Header;
